import { useEditor, useNode } from "@craftjs/core";
import ContentEditable from "react-contenteditable";
import Toolbar from "./Toolbar";

interface TextProps {
    text: string;
}

const SpotlightText = ({ text }: TextProps) => {
    const {
        connectors: { connect },
        actions: { setProp },
    } = useNode();
    const { enabled } = useEditor((state) => ({ enabled: state.options.enabled }));

    return (
        <div ref={(ref) => connect(ref!)} className="content-center text-center break-words slogan">
            <ContentEditable
                html={text || "Title goes here"}
                disabled={!enabled}
                onChange={(e) => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    setProp((prop: any) => (prop.text = e.target.value), 500);
                }}
                tagName="h2"
                className="break-words"
            />
        </div>
    );
};

SpotlightText.craft = {
    displayName: "Caption",
    props: {
        text: "Text",
    },
    related: {
        toolbar: Toolbar,
    },
};

export default SpotlightText;
